const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class FeaturedCtaCarousel extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.layoutMobile = this.dataset.featuredCtaCarouselLayoutMobile
  }

  connectedCallback () {
    super.connectedCallback()

    if (!window.BAO.MediaBreakpoints.isSm && this.layoutMobile === 'stacked') { return }

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        disabled: this.layoutMobile === 'stacked',
        slides: {
          perView: 1.1,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: false,
            slides: {
              perView: 1.1,
              spacing: 15,
            },
          },
          '(min-width: 901px)': {
            disabled: false,
            slides: {
              perView: 1.1,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('featured-cta-carousel')) {
  customElements.define('featured-cta-carousel', FeaturedCtaCarousel)
}
